module.exports = __webpack_public_path__ + "static/media/slide-stone.e569d0ca.jpg";